
import { SELLING_PRODUCT_LIST } from '../../store/store.const'
import SingleProductElement from '../product/single'

export default {
  name: 'SellingProduct',
  components: {
    SingleProductElement
  },
  data() {
    return {
      products: [],
      fullscreenLoading: false
    }
  },
  async fetch() {
    await this.fetchData()
  },
  methods: {
    async fetchData() {
      try {
        const products = await this.$store.dispatch(SELLING_PRODUCT_LIST)
        this.products = products.data
      } catch (e) {
        console.log(e)
      }
    }
  }
}
